module.exports = __webpack_public_path__ + "static/media/vid-tutorial-icon.c31cc869.svg";